import qs from 'qs'
import {
  ROUTER_QS_PARSE_OPTIONS,
  ROUTER_QS_STRINGIFY_OPTIONS,
} from '@lib/queryString'

export function parseSearch(searchStr: string): Record<string, unknown> {
  const raw = searchStr.startsWith('?') ? searchStr.slice(1) : searchStr
  return qs.parse(raw, ROUTER_QS_PARSE_OPTIONS) as Record<string, unknown>
}

export function stringifySearch(search: Record<string, unknown>): string {
  const query = qs.stringify(search, ROUTER_QS_STRINGIFY_OPTIONS)

  return query ? `?${query}` : ''
}
